import React, { useRef, useState } from 'react'
import {Link} from 'react-scroll'
import { motion } from 'framer-motion'
import ScrollToTop from 'react-scroll-to-top'

const Home = () => {

  return (
    <div name='home' className='w-full h-screen bg-gradient-to-b from-gray to-white'>
      <ScrollToTop className='mx-14' smooth />
        {/* Container */}
        <motion.div initial={{ opacity: 0, scale: 0 }} animate={{ opacity: 1, scale: 1 }}  transition={{
          duration: 1.5,
          type: "spring"
         }} className='max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full'>
            <p className='text-black-600 font-bold'>Hello. My name is</p>
            <motion.h1 whileHover={{scale: 1.03}} className='text-4xl sm:text-7xl font-bold text-[#1d1d1d] cursor-default'>Patryk Romański</motion.h1>
            <motion.h2 whileHover={{scale: 1.03}} className='text-4xl sm:text-7xl font-bold text-[#929292] cursor-default'>I am a FullStack Developer.</motion.h2>
            <p className='text-[#929292] py-4 max-w-[700px]'>Fullstack developer with strong willing to do useful features on websites and developing knowledge about UI.</p>
            <div>
            <Link to='experience' smooth={true} duration={500}> <motion.button whileHover={{scale: 1.05}} className='bg-[#d4d4d4] group rounded text-[#3b3b3b] px-6 py-3 my-2 flex items-center hover:bg-[#818181] hover:text-white hover:border-[#5e5e5e] duration-300'>
                    View Work 
                </motion.button></Link>
            </div>
        </motion.div>
    </div>
  )
}

export default Home